import React, { useState, useEffect, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import {
  //eslint-disable-next-line
  validateBankAccount,
  validateContactNumber,
  validateEmail,
  validateName,
  validateRequired,
  validPostalCode,
  getTodaysData,
  validateAadhar,
  validatePAN,
} from "../../../../common/Validations";
import toast from "react-hot-toast";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import Layout from "../../../../Layout/Layout";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
// eslint-disable-next-line
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import CustomerConstants from "../../../../common/CustomerConstants";
import {
  vendorCategoryData,
  dropdownOption,
  employeeGender,
  failureModalData,
  message,
  doctorManagerDropDownOption,
  ID_PROOF_OPTIONS,
  NURSE_CATEGORY_OPTIONS,
  NURSE_SPECIALIZATION_OPTIONS,
} from "./UserRegistrationConstant";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";

const UserRegistrationPageMR = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Hospital-Patient");

  const appConfig = useSelector((state) => state?.app?.appConfig);
  let userData = useSelector((state) => state?.user?.data);

  useEffect(() => {
    if (userData?.roles) {
      const isSalesAdmin = userData.roles.some(
        (role) => role.roleId === "SALES-ADMIN",
      );
      if (!isSalesAdmin) {
        setFormInputs((prev) => ({
          ...prev,
          salesOfficerName: userData.userName || userData.name || "",
          salesOfficerCode: userData.userId || "",
        }));
      }
    }
  }, [userData]);

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [patientDocuments, setPatientDocuments] = useState({
    aadharCardAttachment: "",
    aadharCardFileName: "",
    panCardAttachment: "",
    panCardFileName: "",
    weight: "",
    age: "",
    patientChallanges: "",
    caregiverName: "",
    caregiverMobileNr: "",
    emailId: "",
    caregiverRelation: "",
    idProof: "",
    idProofNumber: "",
  });

  // eslint-disable-next-line
  const SalesOfficerData = [
    { id: 1, code: "M000", name: "Medirent" },
    { id: 2, code: "ST10", name: "Ganesh" },
    { id: 3, code: "MJ25", name: "Manoj" },
    { id: 4, code: "S0003", name: "Sales 3" },
    { id: 5, code: "S0004", name: "Sales 4" },
    { id: 6, code: "S0005", name: "Sales 5" },
  ];

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);

  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);
  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({});

  const [getBankDetails, setBankDetails] = useState([]);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);

  // For Hospital's doctors list (V04)
  const [getDoctorsList, setDoctorsList] = useState([]);

  const [getSalesOfficerList, setSalesOfficerList] = useState([]);

  const [serviceProviderList, setServiceProviderList] = useState([]);

  // Doctor initial structure
  const doctorInitialData = {
    id: Date.now(),
    doctorName: "",
    doctorTitle: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    doctorGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",
    activeInactive: true,
    version: "v0",
    status: "Registered",
    category: "VENDOR",
    type: "SUPPLIER",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    joiningDate: getTodaysData(),
    vendorCategory: [],
    email: "",
    mobileNr: "",
    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",
    jobRole: "",
    otherJobRole: "",

    patientGender: "",
    patientGenderCode: "",

    //  Individual Doctor specific fields (V11) - for header form
    doctorTitle: "",
    // doctorEmpName: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    employeeGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",

    //---Hospital details where individual doctor practices (V11)
    doctorHospitalName: "",
    doctorHospitalAddress: "",
    doctorHospitalCity: "",
    doctorHospitalState: "",
    doctorHospitalCountry: "",
    doctorHospitalPincode: "",
    doctorGNT: "",

    doctorManagerName: "",
    doctorManagerNameCode: "",

    //-- For Nursing Master
    serviceProviderName: "",
    serviceProviderCode: "",
    nurseCategory: "", // Qualification Level (GNM, BSc)
    nurseCategoryCode: "",
    nurseSpecialization: "", // Skill (ICU, General)
    nurseSpecializationCode: "",
    nurseExperience: "", // Years
    nurseRegNo: "", // Licensing
    nurseLanguages: "",

    servicePersonExpertise: "",
    servicePersonExperience: "",
    servicePersonGender: "",
  });

  // eslint-disable-next-line
  const [getCustomerTypeCode, setCustomerTypeCode] = useState();
  const [disabled, setDisabled] = useState(false);
  const [getVendorCategory, setVendorCategory] = useState([]);
  const [selectedVendorCategory, setSelectedVendorCategory] = useState(null);

  // Toggle functions
  const toggleCardVisibility = () => setCardVisible(!isCardVisible);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility10 = () => setCardVisible10(!isCardVisible10);
  const toggleCardVisibility8 = () => setCardVisible8(!isCardVisible8);

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

    if (name === "employeeName") {
      if (!validateName(value)) {
        errors.employeeName = message.VALID_CUSTOMER_NAME;
      } else {
        errors.employeeName = "";
      }
    }

    if (name === "cityPostalCode") {
      if (!validPostalCode(value)) {
        errors.cityPostalCode = message.VALID_POSTAL_CODE;
      } else {
        errors.cityPostalCode = "";
      }
    }

    if (name === "email") {
      if (!validateRequired(value)) {
        errors.email = message.FILL_REQUIRED_FIELD;
      } else if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      } else {
        errors.email = "";
      }
    }

    //-- EmailId of caregiver  validation
    if (name === "emailId") {
      if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      } else {
        errors.email = "";
      }
    }

    setValidation((prev) => ({
      ...prev,
      ...errors,
    }));
  };
  // Master data loading
  const getMasterData = useCallback(async () => {
    try {
      const [titleRes, docTypeRes, jobTitleRes, countryRes, companyRes] =
        await Promise.all([
          ItemService.getMasterDataSelf({ codeType: "title" }),
          ItemService.getMasterDataSelf({ codeType: "documentType" }),
          ItemService.getMasterDataSelf({ codeType: "jobtitle" }),
          ItemService.getMasterDataSelf({ codeType: "country" }),
          ItemService.generateCustomerQuery({
            queryName: "Get_CompanyMaster_List",
            page: 1,
            per_page: 9999,
            searchTerm: "",
            timeZone: "Asia/Calcutta",
          }),
        ]);

      if (titleRes?.status === 200) setTitle(titleRes.data);
      if (docTypeRes?.status === 200) setdocumentType(docTypeRes.data);
      if (jobTitleRes?.status === 200) setcontactPosition(jobTitleRes.data);
      if (countryRes?.status === 200) setCountry(countryRes.data);
      if (companyRes?.status === 200) setCompanyCode(companyRes.data);

      await fetchSalesOfficerList();
    } catch (error) {
      console.error("Error loading master data:", error);
    }
  }, []);

  useEffect(() => {
    getMasterData();
  }, [getMasterData]);

  useEffect(() => {
    if (!getDropdownData) return;

    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textField === "state") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "vendorCategory") {
      setSelectedVendorCategory({
        id: getDropdownData?.id,
        code: getDropdownData?.code,
        name: getDropdownData?.name,
        description: getDropdownData?.description,
      });

      setVendorCategory([
        {
          vendorCategoryCode: getDropdownData?.code,
          vendorCategoryDesc: getDropdownData?.description,
          vendorCategoryName: getDropdownData?.name,
        },
      ]);

      setValidation((prev) => ({
        ...prev,
        vendorCategory: "",
      }));
    } else if (getDropdownData?.textField === "employeeGender") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
    } else if (getDropdownData?.textField === "doctorManagerName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "doctorGNT") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "swiftIfscCode") {
      setBankDetails((prevBankDetails) =>
        prevBankDetails.map((bank) =>
          bank.id === getDropdownData?.index
            ? {
                ...bank,
                swiftIfscCode: getDropdownData?.name,
                swiftIfscCodeCode: getDropdownData?.code,
                swiftIfscCodeDesc: getDropdownData?.description,
              }
            : bank,
        ),
      );

      setValidation((prev) => ({
        ...prev,
        [`${getDropdownData?.index}_swiftIfscCode`]: "",
      }));
    } else if (getDropdownData?.textField === "doctorGender") {
      // For hospital's doctor list (V04)
      setDoctorsList((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                doctorGender: getDropdownData?.name,
                doctorGenderCode: getDropdownData?.code,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "salesOfficerName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "idProof") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "nurseCategory") {
      setFormInputs((prev) => ({
        ...prev,
        nurseCategory: getDropdownData?.name,
        nurseCategoryCode: getDropdownData?.code,
      }));
    }
    // 2. Nurse Specialization (Critical for service mapping)
    else if (getDropdownData?.textField === "nurseSpecialization") {
      setFormInputs((prev) => ({
        ...prev,
        nurseSpecialization: getDropdownData?.name,
        nurseSpecializationCode: getDropdownData?.code,
      }));
    }
    // 3. Service Provider (Existing from previous step)
    else if (getDropdownData?.textField === "serviceProviderName") {
      setFormInputs((prev) => ({
        ...prev,
        serviceProviderName: getDropdownData?.name,
        serviceProviderCode: getDropdownData?.code,
      }));
    }
    // Patient gender handler (V12 - optional field)
    else if (getDropdownData?.textField === "patientGender") {
      setFormInputs((prev) => ({
        ...prev,
        patientGender: getDropdownData?.name,
        patientGenderCode: getDropdownData?.code,
      }));
    } // Service Person gender handler (V14 - optional field)
    else if (getDropdownData?.textField === "servicePersonGender") {
      setFormInputs((prev) => ({
        ...prev,
        servicePersonGender: getDropdownData?.name,
        servicePersonGenderCode: getDropdownData?.code,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  //  BUILD PAYLOAD - THE MOST IMPORTANT FUNCTION
  const buildPayload = () => {
    // Common base payload
    const payload = {
      createdBy: formInputs.createdBy,
      firstName: formInputs.employeeName,
      organisationName: formInputs.employeeName,
      employeeName: formInputs.employeeName,
      email: formInputs.email,
      mobileNr: formInputs.mobileNr,
      address: formInputs.address,
      address2: formInputs.address2,
      city: formInputs.city,
      country: formInputs.country,
      state: formInputs.state,
      cityPostalCode: formInputs.cityPostalCode,
      companyCode: formInputs.companyCode,
      activeInactive: formInputs.activeInactive,
      version: formInputs.version,
      status: formInputs.status,
      category: formInputs.category,
      type: formInputs.type,
      joiningDate: formInputs.joiningDate,
      vendorCategory: getVendorCategory,
      customerTypeCode: "S01",
      disableWorkFlow: true,
      plantAddress: formInputs.plantAddress,
      salesOfficerCode: formInputs.salesOfficerCode,
      salesOfficerName: formInputs.salesOfficerName,

      // --- V13 Specifics ---
      serviceProviderName: formInputs.serviceProviderName,
      serviceProviderCode: formInputs.serviceProviderCode,

      nurseRegNo: formInputs.nurseRegNo,
      nurseExperience: formInputs.nurseExperience,
      nurseCategory: formInputs.nurseCategory,
      nurseCategoryCode: formInputs.nurseCategoryCode,
      nurseSpecialization: formInputs.nurseSpecialization,
      nurseSpecializationCode: formInputs.nurseSpecializationCode,
      nurseLanguages: formInputs.nurseLanguages,

      hospitalName: "",

      // Related data
      contactDetails: getcustomerContactPerson.map((contact) => ({
        contactPosition: contact.contactPosition,
        contactPositionCode: contact.contactPositionCode,
        contactTitle: contact.contactTitle,
        contactTitleCode: contact.contactTitleCode,
        contactName: contact.contactName,
        contactNumber: contact.contactNumber,
        contactEmail: contact.contactEmail,
      })),

      certifications: getDocumentTypeData.map((doc) => ({
        documentType: doc.documentType,
        documentTypeCode: doc.documentTypeCode,
        documentNumber: doc.documentNumber,
        issueDate: doc.issueDate,
        issuingAuthority: doc.issuingAuthority,
        certificateCode: doc.certificateCode,
        iSOCertification: doc.iSOCertification,
      })),

      bandkDetails: getBankDetails.map((bank) => ({
        bankNotListed: bank.bankNotListed,
        bankAccountNumber: bank.bankAccountNumber,
        bankKey: bank.bankKey,
        bankName: bank.bankName,
        bankCountry: bank.bankCountryDescription,
        bankAddress: bank.bankAddress,
        AccountHolderName: bank.AccountHolderName,
        bankCompanyletterhead: bank.bankCompanyletterhead,
        bankConfirmationLetter: bank.bankConfirmationLetter,
        swiftIfscCode: bank.swiftIfscCode,
        bankIFSC: bank.bankIFSC,
        preferredCurrency: bank.preferredCurrency,
      })),
    };

    //  CASE 1: INDIVIDUAL DOCTOR (V11)
    // doctorsDetails contains ONLY this doctor's info with hospital details
    if (selectedVendorCategory?.code === "V11") {
      // Set the Hospital Name for the Header
      payload.hospitalName = formInputs.doctorHospitalName;

      payload.doctorTitle = formInputs.doctorTitle;
      payload.doctorSpecialityCode = formInputs.doctorSpecialityCode;
      payload.doctorSpecialityName = formInputs.doctorSpecialityName;
      payload.doctorType = formInputs.doctorType;
      payload.employeeGender = formInputs.employeeGender;
      payload.doctorClass = formInputs.doctorClass;
      payload.doctorRentPercentage = formInputs.doctorRentPercentage;
      payload.doctorDiscountPercentage = formInputs.doctorDiscountPercentage;
      payload.doctorHospitalName = formInputs.doctorHospitalName;
      payload.doctorHospitalAddress = formInputs.doctorHospitalAddress;
      payload.doctorHospitalCity = formInputs.doctorHospitalCity;
      payload.doctorHospitalState = formInputs.doctorHospitalState;
      payload.doctorHospitalCountry = formInputs.doctorHospitalCountry;
      payload.doctorHospitalPincode = formInputs.doctorHospitalPincode;
      payload.doctorGNT = formInputs.doctorGNT;
      payload.doctorManagerName = formInputs.doctorManagerName;
      payload.doctorManagerCode = formInputs.doctorManagerNameCode;

      payload.doctorsDetails = [
        {
          doctorName: formInputs.employeeName,
          doctorTitle: formInputs.doctorTitle,
          // doctorEmpName: formInputs.doctorEmpName,
          doctorSpecialityCode: formInputs.doctorSpecialityCode,
          doctorSpecialityName: formInputs.doctorSpecialityName,
          doctorType: formInputs.doctorType,
          doctorGender: formInputs.employeeGender,
          doctorClass: formInputs.doctorClass,
          doctorRentPercentage: formInputs.doctorRentPercentage,
          doctorDiscountPercentage: formInputs.doctorDiscountPercentage,

          //  CRITICAL: Hospital details where doctor practices
          doctorHospitalName: formInputs.doctorHospitalName,
          doctorHospitalAddress: formInputs.doctorHospitalAddress,
          doctorHospitalCity: formInputs.doctorHospitalCity,
          doctorHospitalState: formInputs.doctorHospitalState,
          doctorHospitalCountry: formInputs.doctorHospitalCountry,
          doctorHospitalPincode: formInputs.doctorHospitalPincode,
          doctorGNT: formInputs.doctorGNT,

          doctorManagerName: formInputs.doctorManagerName,
          doctorManagerCode: formInputs.doctorManagerNameCode,
        },
      ];
    }

    //  CASE 2: HOSPITAL (V04)
    // doctorsDetails contains list of employed doctors
    // Each doctor's hospital fields should be EMPTY
    else if (selectedVendorCategory?.code === "V04") {
      // 1. Set the Hospital Name (The user IS the hospital)
      payload.hospitalName = formInputs.employeeName;

      payload.doctorsDetails = getDoctorsList.map((doctor) => ({
        doctorName: doctor.doctorName,
        doctorTitle: doctor.doctorTitle,
        doctorSpecialityCode: doctor.doctorSpecialityCode,
        doctorSpecialityName: doctor.doctorSpecialityName,
        doctorType: doctor.doctorType,
        doctorGender: doctor.doctorGender,
        doctorClass: doctor.doctorClass,
        doctorRentPercentage: doctor.doctorRentPercentage,
        doctorDiscountPercentage: doctor.doctorDiscountPercentage,

        //  IMPORTANT: Empty for hospital's doctors
        // Hospital info is in main user record
        doctorHospitalName: formInputs.employeeName,
        doctorHospitalAddress: formInputs.address,
        doctorHospitalCity: formInputs.city,
        doctorHospitalState: formInputs.state,
        doctorHospitalCountry: formInputs.country,
        doctorHospitalPincode: formInputs.cityPostalCode,
        doctorGNT: formInputs.doctorGNT,
      }));
    } else if (selectedVendorCategory?.code === "V12") {
      //---Patient-specific fields
      payload.aadharNo = formInputs.aadharNo;
      payload.panNo = formInputs.panNo;
      payload.weight = formInputs.weight;
      payload.age = formInputs.age;
      payload.patientChallenges = formInputs.patientChallenges;
      payload.caregiverName = formInputs.caregiverName;
      payload.caregiverMobileNr = formInputs.caregiverMobileNr;
      payload.emailId = formInputs.emailId;
      payload.caregiverRelation = formInputs.caregiverRelation;
      payload.idProof = formInputs.idProof;
      payload.idProofNumber = formInputs.idProofNumber;

      payload.patientGender = formInputs.patientGender;
      payload.patientGenderCode = formInputs.patientGenderCode;

      //---------Patient document attachments----------
      payload.aadharCardAttachment = patientDocuments.aadharCardAttachment;
      payload.aadharCardFileName = patientDocuments.aadharCardFileName;

      payload.panCardAttachment = patientDocuments.panCardAttachment;
      payload.panCardFileName = patientDocuments.panCardFileName;

      payload.doctorsDetails = [
        {
          doctorHospitalName: formInputs.doctorHospitalName,
          doctorHospitalAddress: formInputs.doctorHospitalAddress,
          doctorHospitalCity: formInputs.doctorHospitalCity,
          doctorHospitalState: formInputs.doctorHospitalState,
          doctorHospitalCountry: formInputs.doctorHospitalCountry,
          doctorHospitalPincode: formInputs.doctorHospitalPincode,
          // Include any other relevant fields for V12 here
        },
      ];
    } else if (selectedVendorCategory?.code === "V14") {
      //---Service Person-specific fields
      payload.aadharNo = formInputs.aadharNo;
      payload.servicePersonExpertise = formInputs.servicePersonExpertise;
      payload.servicePersonExperience = formInputs.servicePersonExperience;
      payload.servicePersonGender = formInputs.servicePersonGender;

      //---------Patient document attachments----------
      payload.aadharCardAttachment = patientDocuments.aadharCardAttachment;
      payload.aadharCardFileName = patientDocuments.aadharCardFileName;
    }

    //  CASE 3: OTHER VENDOR CATEGORIES (V01, V02, etc.)
    // No doctorsDetails needed
    else {
      payload.doctorsDetails = [];
    }

    return payload;
  };

  // VALIDATION & SAVE HANDLER
  const handleSave = async () => {
    // eslint-disable-next-line
    const requiredFields = [];
    let hasError = false;
    const validationErrors = {};

    // Common validations
    if (!validateRequired(formInputs.employeeName)) {
      validationErrors.employeeName = message.FILL_REQUIRED_FIELD;
      hasError = true;
    } else if (!validateName(formInputs.employeeName)) {
      validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
      hasError = true;
    }

    if (!validateRequired(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.FILL_REQUIRED_FIELD;
      hasError = true;
    } else if (!validateContactNumber(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.MOBILE_NUMBER;
      hasError = true;
    }

    // if (!validateRequired(formInputs.email)) {
    //   validationErrors.email = message.FILL_REQUIRED_FIELD;
    //   hasError = true;
    // } else if (!validateEmail(formInputs.email)) {
    //   validationErrors.email = message.VALID_MAIL_ID;
    //   hasError = true;
    // }

    if (selectedVendorCategory?.code !== "V13") {
      if (!validateRequired(formInputs.email)) {
        validationErrors.email = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateEmail(formInputs.email)) {
        validationErrors.email = message.VALID_MAIL_ID;
        hasError = true;
      }
    } else {
      // V13: only validate format if email is provided
      if (formInputs.email && !validateEmail(formInputs.email)) {
        validationErrors.email = message.VALID_MAIL_ID;
        hasError = true;
      }
    }

    if (!validateRequired(formInputs.address)) {
      validationErrors.address = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }

    if (!validateRequired(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.FILL_REQUIRED_FIELD;
      hasError = true;
    } else if (!validPostalCode(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.VALID_POSTAL_CODE;
      hasError = true;
    }
    if (!validateRequired(formInputs.salesOfficerName)) {
      validationErrors.salesOfficerName = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }

    if (!selectedVendorCategory || !selectedVendorCategory?.code) {
      validationErrors.vendorCategory = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }

    if (!validateRequired(formInputs.companyCode)) {
      validationErrors.companyCode = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }

    //  CONDITIONAL VALIDATION FOR INDIVIDUAL DOCTOR (V11)
    if (selectedVendorCategory?.code === "V11") {
      if (!validateRequired(formInputs.doctorType)) {
        validationErrors.doctorType = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.employeeGender)) {
        validationErrors.employeeGender = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorClass)) {
        validationErrors.doctorClass = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }

      //  Hospital details are REQUIRED for individual doctors
      if (!validateRequired(formInputs.doctorHospitalName)) {
        validationErrors.doctorHospitalName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorHospitalAddress)) {
        validationErrors.doctorHospitalAddress = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorManagerName)) {
        validationErrors.doctorManagerName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorGNT)) {
        validationErrors.doctorGNT = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    }

    if (selectedVendorCategory?.code === "V13") {
      // 1. Agency/Provider
      if (!validateRequired(formInputs.serviceProviderName)) {
        validationErrors.serviceProviderName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 2. Registration Number
      if (!validateRequired(formInputs.nurseRegNo)) {
        validationErrors.nurseRegNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 3. Category (Qualification)
      if (!validateRequired(formInputs.nurseCategory)) {
        validationErrors.nurseCategory = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 4. Specialization (Crucial for service mapping)
      if (!validateRequired(formInputs.nurseSpecialization)) {
        validationErrors.nurseSpecialization = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.employeeGender)) {
        validationErrors.employeeGender = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    }

    //  CONDITIONAL VALIDATION FOR PATIENT (V12) - Document Uploads
    if (selectedVendorCategory?.code === "V12") {
      if (!validateRequired(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateAadhar(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.VALID_AADHAAR_NUMBER;
        hasError = true;
      } else if (!validateName(formInputs.employeeName)) {
        validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
        hasError = true;
      } else if (!validateRequired(formInputs.caregiverMobileNr)) {
        validationErrors.caregiverMobileNr = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }

      if (!validateRequired(formInputs.panNo)) {
        validationErrors.panNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validatePAN(formInputs.panNo)) {
        validationErrors.panNo = message.VALID_PAN_NUMBER;
        hasError = true;
      }

      //  Make document uploads mandatory
      if (!patientDocuments.aadharCardAttachment) {
        toast.error("Please upload Aadhaar card");
        hasError = true;
      }
      if (!patientDocuments.panCardAttachment) {
        toast.error("Please upload PAN card");
        hasError = true;
      }
    }

    if (selectedVendorCategory?.code === "V14") {
      if (!validateRequired(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateAadhar(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.VALID_AADHAAR_NUMBER;
        hasError = true;
      } else if (!validateName(formInputs.employeeName)) {
        validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
        hasError = true;
      }
      //  Make document uploads mandatory
      if (!patientDocuments.aadharCardAttachment) {
        toast.error("Please upload Aadhaar card");
        hasError = true;
      }
    }

    // // Contact person validation
    // getcustomerContactPerson.forEach((doc) => {
    //   const id = doc.id;

    //   if (!doc.contactPosition) {
    //     validationErrors[`${id}_contactPosition`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    //   if (!doc.contactTitle) {
    //     validationErrors[`${id}_contactTitle`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    //   if (!doc.contactName) {
    //     validationErrors[`${id}_contactName`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   } else if (!validateName(doc.contactName)) {
    //     validationErrors[`${id}_contactName`] = message.VALID_CUSTOMER_NAME;
    //     hasError = true;
    //   }
    //   if (!doc.contactNumber) {
    //     validationErrors[`${id}_contactNumber`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   } else if (!validateContactNumber(doc.contactNumber)) {
    //     validationErrors[`${id}_contactNumber`] = message.VALID_CONTACT_NUMBER;
    //     hasError = true;
    //   }
    // });

    // // Document validation
    // getDocumentTypeData.forEach((doc) => {
    //   const id = doc.id;
    //   if (!doc.documentType) {
    //     validationErrors[`${id}_documentType`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    //   if (!doc.documentNumber) {
    //     validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    // });

    // // Bank validation
    // getBankDetails.forEach((doc) => {
    //   const id = doc.id;
    //   if (doc.bankNotListed === "Yes") {
    //     if (!doc.bankAccountNumber) {
    //       validationErrors[`${id}_bankAccountNumber`] =
    //         message.FILL_REQUIRED_FIELD;
    //       hasError = true;
    //     } else if (!validateBankAccount(doc.bankAccountNumber)) {
    //       validationErrors[`${id}_bankAccountNumber`] = message.VALID_BANK_ACC;
    //       hasError = true;
    //     }
    //     if (!doc.bankIFSC) {
    //       validationErrors[`${id}_bankIFSC`] = message.FILL_REQUIRED_FIELD;
    //       hasError = true;
    //     }
    //     if (!doc.AccountHolderName) {
    //       validationErrors[`${id}_AccountHolderName`] =
    //         message.FILL_REQUIRED_FIELD;
    //       hasError = true;
    //     }
    //   }
    // });

    setValidation(validationErrors);

    if (hasError) {
      const errorMessages = Object.values(validationErrors).filter(Boolean);
      setErrorFields(errorMessages);
      setShowFailureModal(true);
      return;
    }

    //  BUILD AND SEND PAYLOAD
    const payload = buildPayload();

    setDisabled(true);
    try {
      // console.log("Final Payload:", JSON.stringify(payload, null, 2));

      const item = await ItemService.addSupplier({ data: payload });

      if (item?.status === 200) {
        toast.success("User created successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(CustomerConstants.CUSTOMER_V5_MR_USER_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.error("Error creating user:", err);
      toast.error("Something went wrong");
    } finally {
      setDisabled(false);
    }
  };

  const getStateData = async (code) => {
    try {
      const item = await ItemService.getMasterDataSelf({
        codeType: "region",
        code: code,
      });
      if (item?.status === 200) {
        setState(item.data);
      }
    } catch (error) {
      console.error("Error loading state data:", error);
    }
  };

  const getBankMasterData = async () => {
    try {
      const item = await ItemService.getBankMasterData();
      if (item?.status === 200) {
        setBankDetailsData(item.data);
      }
    } catch (error) {
      console.error("Error loading bank data:", error);
    }
  };

  useEffect(() => {
    getBankMasterData();
  }, []);

  // Place this near your other API calls like fetchHospitalList

  const fetchServiceProviderList = async () => {
    // You can add a loading state here if you want
    try {
      const payload = {
        queryName: "getSupplierList",
        module: "",
        page: 1,
        per_page: 1000, // Fetch enough records
        timeZone: "Asia/Calcutta",
        rowFilter: {
          $and: [
            {
              "vendorCategory.vendorCategoryCode": "V06", // FILTER FOR SERVICE PROVIDERS
            },
          ],
        },
      };

      const response = await ItemService.generateQuery(payload);

      if (response?.status === 200 && Array.isArray(response.data)) {
        // Map data to match the structure ComboboxField expects (id, name, code)
        const formattedList = response.data.map((provider) => ({
          id: provider.userId || provider._id,
          name: provider.organisationName || provider.employeeName, // Ensure we get a name
          code: provider.userId,
          description:
            provider.vendorCategory?.[0]?.vendorCategoryName ||
            "Service Provider",
        }));

        setServiceProviderList(formattedList);
      } else {
        setServiceProviderList([]);
      }
    } catch (err) {
      console.error("Error fetching Service Providers:", err);
      toast.error("Failed to load Service Provider list");
      setServiceProviderList([]);
    }
  };

  const fetchSalesOfficerList = async () => {
    try {
      const response = await ItemService.generateQuery({
        queryName: "Get_SalesOfficerNames",
        page: 1,
        per_page: 9999,
        timeZone: "Asia/Calcutta",
      });

      if (response?.status === 200 && Array.isArray(response.data)) {
        // Response already has id, name, code structure we need
        const formattedList = response.data.map((officer) => ({
          id: officer.salesOfficerCode,
          name: officer.salesOfficerName,
          code: officer.salesOfficerCode,
          description: officer.desc,
        }));
        setSalesOfficerList(formattedList);
      } else {
        setSalesOfficerList([]);
      }
    } catch (error) {
      console.error("Error fetching sales officers:", error);
      toast.error("Failed to load Sales Officer list");
      setSalesOfficerList([]);
    }
  };

  useEffect(() => {
    if (
      selectedVendorCategory?.code === "V13" ||
      selectedVendorCategory?.code === "V14"
    ) {
      fetchServiceProviderList();
    }
  }, [selectedVendorCategory]);

  // Contact Person handlers
  const deleteCustomerContactPerosn = (id) => {
    setcustomerContactPerson((prev) => prev.filter((doc) => doc.id !== id));
  };

  const addCustomerCantactPerson = () => {
    setcustomerContactPerson((prev) => [
      ...prev,
      {
        id: Date.now(),
        contactPosition: "",
        contactTitle: "",
        contactName: "",
        contactNumber: "",
        contactEmail: "",
      },
    ]);
  };

  // const handleChangeCustomerContacts = (id, fieldName, value) => {
  //   const errors = {};

  //   if (!validateRequired(value)) {
  //     errors[fieldName] = message.FILL_REQUIRED_FIELD;
  //   }

  //   if (fieldName === "contactNumber" && validateRequired(value)) {
  //     if (!validateContactNumber(value)) {
  //       errors[fieldName] = message.VALID_CONTACT_NUMBER;
  //     }
  //   }

  //   if (fieldName === "contactName" && validateRequired(value)) {
  //     if (!validateName(value)) {
  //       errors[fieldName] = message.VALID_CUSTOMER_NAME;
  //     }
  //   }

  //   setcustomerContactPerson((prev) =>
  //     prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
  //   );

  //   setValidation((prev) => ({
  //     ...prev,
  //     [`${id}_${fieldName}`]: errors[fieldName] || "",
  //   }));
  // };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    //  UPDATED: Only validate format if user enters data
    // Don't make fields required anymore

    if (fieldName === "contactNumber" && value) {
      // Only validate if there's a value
      if (!validateContactNumber(value)) {
        errors[fieldName] = message.VALID_CONTACT_NUMBER;
      }
    }

    if (fieldName === "contactName" && value) {
      // Only validate if there's a value
      if (!validateName(value)) {
        errors[fieldName] = message.VALID_CUSTOMER_NAME;
      }
    }

    setcustomerContactPerson((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  // Document handlers
  const deleteDocumentType = (id) => {
    setDocumentTypeData((prev) => prev.filter((doc) => doc.id !== id));
  };

  const addDocumentType = () => {
    setDocumentTypeData((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: `Document ${prev.length + 1}`,
        documentType: "",
        documentNumber: "",
        issueDate: "",
        issuingAuthority: "",
        certificateCode: "",
      },
    ]);
  };

  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: "",
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prev) =>
      prev.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  // Bank handlers
  const bankInfoInitialData = {
    id: Date.now().toString(),
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "INR",
    bankIFSC: "",
  };

  const addBankForm = () => {
    setBankDetails((prev) => [
      ...prev,
      { ...bankInfoInitialData, id: Date.now().toString() },
    ]);
  };

  const removeBankForm = (indexToRemove) => {
    setBankDetails((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  // const handleChangeBankInfo = (id, key, value) => {
  //   setBankDetails((prev) =>
  //     prev.map((item) => {
  //       if (item.id === id) {
  //         const updates = { [key]: value };

  //         if (key === "bankKey") {
  //           const selectedBank = getBankDetailsData.find(
  //             (bank) => bank.name === value,
  //           );
  //           if (selectedBank) {
  //             Object.assign(updates, {
  //               bankCountryDescription: selectedBank.bankCountryDescription,
  //               bankAccountName: selectedBank.bankAccountName,
  //               bankAddress: selectedBank.bankAddress,
  //               bankBranchName: selectedBank.bankBranchName,
  //             });
  //           }
  //         }

  //         return { ...item, ...updates };
  //       }
  //       return item;
  //     }),
  //   );

  //   setValidation((prev) => ({
  //     ...prev,
  //     [`${id}_${key}`]: !value ? message.FILL_REQUIRED_FIELD : "",
  //   }));
  // };
  const handleChangeBankInfo = (id, key, value) => {
    setBankDetails((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const updates = { [key]: value };

          if (key === "bankKey") {
            const selectedBank = getBankDetailsData.find(
              (bank) => bank.name === value,
            );
            if (selectedBank) {
              Object.assign(updates, {
                bankCountryDescription: selectedBank.bankCountryDescription,
                bankAccountName: selectedBank.bankAccountName,
                bankAddress: selectedBank.bankAddress,
                bankBranchName: selectedBank.bankBranchName,
              });
            }
          }

          return { ...item, ...updates };
        }
        return item;
      }),
    );

    //  UPDATED: Remove the validation that makes fields required
    // Only clear any existing errors
    setValidation((prev) => ({
      ...prev,
      [`${id}_${key}`]: "", // Just clear errors, don't validate
    }));
  };
  const onSuccessUploadBankDocumentType = (data, index) => {
    setBankDetails((prev) => {
      const updated = [...prev];
      updated[index][data.fieldName] = data.attachmentId;
      return updated;
    });
  };

  const onSuccessUploadAadhaarCard = (data) => {
    // 1. Get the system generated filename from results array
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";

    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }

    // 2. Store both ID and FileName in state
    setPatientDocuments((prev) => ({
      ...prev,
      aadharCardAttachment: attachmentId,
      aadharCardFileName: fileName, // Store the exact system filename
    }));

    toast.success("Aadhaar card uploaded successfully");
  };

  // Handler for PAN card upload
  const onSuccessUploadPanCard = (data) => {
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";

    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }

    setPatientDocuments((prev) => ({
      ...prev,
      panCardAttachment: attachmentId,
      panCardFileName: fileName, // Store the exact system filename
    }));

    toast.success("PAN card uploaded successfully");
  };
// eslint-disable-next-line
  const handleDeletePatientDocument = async (docType) => {
    const documentData =
      docType === "aadhaar"
        ? {
            fileName: patientDocuments.aadharCardFileName,
            attachmentId: patientDocuments.aadharCardAttachment,
          }
        : {
            fileName: patientDocuments.panCardFileName,
            attachmentId: patientDocuments.panCardAttachment,
          };

    if (!documentData.attachmentId) {
      toast.error("No document to delete");
      return;
    }

    try {
      const response = await ItemService.deleteFile(documentData);

      if (response && response.message) {
        // Clear the state
        if (docType === "aadhaar") {
          setPatientDocuments((prev) => ({
            ...prev,
            aadharCardAttachment: "",
            aadharCardFileName: "",
          }));
        } else {
          setPatientDocuments((prev) => ({
            ...prev,
            panCardAttachment: "",
            panCardFileName: "",
          }));
        }

        // Show success message
        toast.success(
          `${docType === "aadhaar" ? "Aadhaar" : "PAN"} card deleted successfully`,
        );
      } else {
        // This handles cases where response might be null or empty
        toast.error("Failed to delete document");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Error deleting document");
    }
  };

  // Doctor handlers (for Hospital - V04)
  const addDoctor = () => {
    setDoctorsList((prev) => [
      ...prev,
      { ...doctorInitialData, id: Date.now() },
    ]);
  };

  const deleteDoctor = (id) => {
    setDoctorsList((prev) => prev.filter((doc) => doc.id !== id));
  };

  const handleDoctorInputChange = (id, fieldName, value) => {
    setDoctorsList((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );

    setValidation((prev) => ({ ...prev, [`${id}_${fieldName}`]: "" }));
  };

  // File viewer
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    // If NO files remain, clear the field
    if (!hasFiles) {
      console.log("No files remaining, clearing attachment");
      setFormInputs((prev) => ({
        ...prev,
        [attachmentId.fieldName || attachmentId]: "",
      }));
    } else {
      console.log("Files still exist, count:", remainingCount);
    }
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Registration</h2>
            <p className="subText">
              Register as a new Hospital or Doctor with our Company
            </p>
            <hr />

            {/* Save Button at Top */}
            <Row className="mb-4">
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>

            {/* USER DETAILS ACCORDION */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">U</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">User</span>
                      <span className="subHeaderTitle">Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Category"
                          name="vendorCategory"
                          code="vendorCategoryCode"
                          description="vendorCategoryDesc"
                          data={vendorCategoryData}
                          id="vendorCategory"
                          iconClassName="dropdownIcon"
                          setValue={selectedVendorCategory}
                          error={validation?.vendorCategory}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Name"
                          name="employeeName"
                          placeholder=""
                          value={formInputs?.employeeName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation?.employeeName}
                        />
                      </Col>
                      {selectedVendorCategory?.code === "V13" && (
                        <>
                          <Col xs={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Professional Nursing Details
                            </h6>
                          </Col>

                          {/* Row 1: Service Provider (Agency) & Registration */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Service Provider (Agency)"
                                placeholder="Select Service Provider"
                                data={serviceProviderList}
                                name="serviceProviderName"
                                textField="name"
                                code="serviceProviderCode"
                                setValue={formInputs.serviceProviderName}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.serviceProviderName}
                                id="serviceProviderName"
                                iconClassName="dropdownIcon"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Nursing Council Reg No"
                                name="nurseRegNo"
                                placeholder=""
                                value={formInputs?.nurseRegNo || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation?.nurseRegNo}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Years of Experience"
                                name="nurseExperience"
                                type="number"
                                placeholder="e.g. 5"
                                value={formInputs?.nurseExperience || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation?.nurseExperience}
                              />
                            </Col>
                          </Row>

                          {/* Row 2: Category, Specialization & Languages */}
                          <Row className="mt-3">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Nurse Category (Qualification)"
                                placeholder="Select Category"
                                data={NURSE_CATEGORY_OPTIONS}
                                name="nurseCategory"
                                textField="name"
                                code="nurseCategoryCode"
                                setValue={formInputs.nurseCategory}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.nurseCategory}
                                id="nurseCategory"
                                iconClassName="dropdownIcon"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Specialization (Service Capability)"
                                placeholder="Select Specialization"
                                data={NURSE_SPECIALIZATION_OPTIONS}
                                name="nurseSpecialization"
                                textField="name"
                                code="nurseSpecializationCode"
                                setValue={formInputs.nurseSpecialization}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.nurseSpecialization}
                                id="nurseSpecialization"
                                iconClassName="dropdownIcon"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Languages Known"
                                name="nurseLanguages"
                                placeholder="e.g. English, Hindi, Kannada"
                                value={formInputs?.nurseLanguages || ""}
                                onChange={onInputChange}
                                required={false}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="employeeGender"
                                code="employeeGenderCode"
                                description="employeeGenderDesc"
                                data={employeeGender}
                                id="employeeGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.employeeGender}
                                error={validation?.employeeGender}
                                getvalue={setDropdownData}
                                required={true}
                              />
                            </Col>
                          </Row>
                        </>
                      )}
                      {selectedVendorCategory?.code === "V14" && (
                        <>
                          <Col xs={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Professional Details
                            </h6>
                          </Col>

                          {/* Row 1: Service Provider (Agency) & Registration */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Service Provider (Agency)"
                                placeholder="Select Service Provider"
                                data={serviceProviderList}
                                name="serviceProviderName"
                                textField="name"
                                code="serviceProviderCode"
                                setValue={formInputs.serviceProviderName}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.serviceProviderName}
                                id="serviceProviderName"
                                iconClassName="dropdownIcon"
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Years of Experience"
                                name="servicePersonExperience"
                                type="number"
                                placeholder="e.g. 5"
                                value={
                                  formInputs?.servicePersonExperience || ""
                                }
                                onChange={onInputChange}
                                required={true}
                                error={validation?.servicePersonExperience}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="servicePersonGender"
                                code="servicePersonGenderCode"
                                description="servicePersonGenderDesc"
                                data={employeeGender}
                                id="servicePersonGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.servicePersonGender}
                                error={validation?.servicePersonGender}
                                getvalue={setDropdownData}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Expertises"
                                name="servicePersonExpertise"
                                placeholder="Professional Skills"
                                value={formInputs?.servicePersonExpertise || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation?.servicePersonExpertise}
                              />
                            </Col>
                          </Row>
                          {/* Aadhaar Number Input */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Aadhaar No"
                                name="aadharNo"
                                type="number"
                                placeholder="Enter Your Aadhar No"
                                required={true}
                                value={formInputs.aadharNo || ""}
                                onChange={onInputChange}
                                error={validation.aadharNo}
                              />
                            </Col>

                            {/* Aadhaar Card Upload */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponentForHB
                                    id="aadharCard"
                                    name="aadharCard"
                                    label="Upload Aadhaar Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    onSuccessUpload={onSuccessUploadAadhaarCard}
                                    value={
                                      patientDocuments.aadharCardAttachment ||
                                      ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  {patientDocuments.aadharCardAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          patientDocuments.aadharCardAttachment,
                                        )
                                      }
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}

                      {/*  CONDITIONAL FIELDS FOR INDIVIDUAL DOCTOR (V11) */}
                      {selectedVendorCategory?.code === "V11" && (
                        <>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Emp Name"
                              name="doctorEmpName"
                              value={formInputs?.doctorEmpName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorEmpName}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title"
                              name="doctorTitle"
                              placeholder="e.g. DR, PM"
                              value={formInputs?.doctorTitle || ""}
                              onChange={onInputChange}
                              error={validation?.doctorTitle}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality Code"
                              name="doctorSpecialityCode"
                              placeholder="e.g. VS, DR, EN"
                              value={formInputs?.doctorSpecialityCode || ""}
                              onChange={onInputChange}
                              error={validation?.doctorSpecialityCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality"
                              name="doctorSpecialityName"
                              placeholder="e.g. Cardiology"
                              value={formInputs?.doctorSpecialityName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorSpecialityName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              placeholder="e.g. Doctor, Physio"
                              value={formInputs?.doctorType || ""}
                              onChange={onInputChange}
                              required={true}
                              error={validation?.doctorType}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Gender"
                              name="employeeGender"
                              code="employeeGenderCode"
                              description="employeeGenderDesc"
                              data={employeeGender}
                              id="employeeGender"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.employeeGender}
                              error={validation?.employeeGender}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>

                          {/*  CRITICAL: Hospital Details for Individual Doctor */}
                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Hospital/Clinic Details
                            </h6>
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Name"
                              name="doctorHospitalName"
                              placeholder="Enter hospital or clinic name"
                              value={formInputs?.doctorHospitalName || ""}
                              onChange={onInputChange}
                              required={true}
                              error={validation?.doctorHospitalName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Address"
                              name="doctorHospitalAddress"
                              placeholder="Enter hospital or clinic address"
                              value={formInputs?.doctorHospitalAddress || ""}
                              onChange={onInputChange}
                              required={true}
                              error={validation?.doctorHospitalAddress}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital City"
                              name="doctorHospitalCity"
                              placeholder="Enter city"
                              value={formInputs?.doctorHospitalCity || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalCity}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital State"
                              name="doctorHospitalState"
                              placeholder="Enter state"
                              value={formInputs?.doctorHospitalState || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalState}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital Pincode"
                              name="doctorHospitalPincode"
                              placeholder="Enter pincode"
                              value={formInputs?.doctorHospitalPincode || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalPincode}
                            />
                          </Col>

                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Additional Doctor Details
                            </h6>
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              placeholder="e.g. FA, CORE"
                              value={formInputs?.doctorClass || ""}
                              onChange={onInputChange}
                              required={true}
                              error={validation?.doctorClass}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Rent Percentage"
                              name="doctorRentPercentage"
                              type="number"
                              value={formInputs?.doctorRentPercentage || ""}
                              onChange={onInputChange}
                              error={validation?.doctorRentPercentage}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Discount Rate"
                              type="number"
                              name="doctorDiscountPercentage"
                              value={formInputs?.doctorDiscountPercentage || ""}
                              onChange={onInputChange}
                              error={validation?.doctorDiscountPercentage}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Manager"
                              name="doctorManagerName"
                              code="doctorManagerNameCode"
                              description="doctorManagerNameDesc"
                              data={doctorManagerDropDownOption}
                              id="doctorManagerName"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.doctorManagerName}
                              error={validation?.doctorManagerName}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Doctor GNT"
                              name="doctorGNT"
                              code="doctorGNTCode"
                              description="doctorGNTDesc"
                              data={dropdownOption}
                              id="doctorGNT"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.doctorGNT}
                              error={validation?.doctorGNT}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                        </>
                      )}

                      {/* COMMON FIELDS FOR ALL CATEGORIES */}
                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          Contact Information
                        </h6>
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Mobile"
                          name="mobileNr"
                          type="number"
                          placeholder=""
                          required={true}
                          value={formInputs.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation.mobileNr}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          required={selectedVendorCategory?.code !== "V13"}
                          placeholder="Enter Your Email Id"
                          value={formInputs.email || ""}
                          onChange={onInputChange}
                          error={validation.email}
                        />
                      </Col>

                      {selectedVendorCategory?.code === "V12" && (
                        <>
                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Document Information
                            </h6>
                          </Col>

                          {/* Aadhaar Number Input */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Aadhaar No"
                                name="aadharNo"
                                type="number"
                                placeholder="Enter Your Aadhar No"
                                required={true}
                                value={formInputs.aadharNo || ""}
                                onChange={onInputChange}
                                error={validation.aadharNo}
                              />
                            </Col>

                            {/* Aadhaar Card Upload */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponentForHB
                                    id="aadharCard"
                                    name="aadharCard"
                                    label="Upload Aadhaar Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    onSuccessUpload={onSuccessUploadAadhaarCard}
                                    value={
                                      patientDocuments.aadharCardAttachment ||
                                      ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  {patientDocuments.aadharCardAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          patientDocuments.aadharCardAttachment,
                                        )
                                      }
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            {/* PAN Number Input */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN No"
                                name="panNo"
                                required={true}
                                placeholder="Enter Pan No"
                                value={formInputs.panNo || ""}
                                onChange={onInputChange}
                                error={validation.panNo}
                              />
                            </Col>

                            {/* PAN Card Upload - New Row */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponentForHB
                                    id="panCard"
                                    name="panCard"
                                    label="Upload PAN Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    onSuccessUpload={onSuccessUploadPanCard}
                                    value={
                                      patientDocuments.panCardAttachment || ""
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  {patientDocuments.panCardAttachment && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          patientDocuments.panCardAttachment,
                                        )
                                      }
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Extra Information
                            </h6>
                          </Col>

                          <Row>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Weight"
                                name="weight"
                                type="number"
                                placeholder="Enter Patient Weight"
                                // required={true}
                                value={formInputs.weight || ""}
                                onChange={onInputChange}
                                error={validation.weight}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Age"
                                name="age"
                                type="number"
                                placeholder="Enter Patient Age"
                                // required={true}
                                value={formInputs.age || ""}
                                onChange={onInputChange}
                                error={validation.age}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="patientGender"
                                code="patientGenderCode"
                                description="patientGenderDesc"
                                data={employeeGender}
                                id="patientGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.patientGender}
                                getvalue={setDropdownData}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Patient Challenges"
                                name="patientChallenges"
                                value={formInputs.patientChallenges}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Name"
                                name="caregiverName"
                                value={formInputs.caregiverName}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Mobile No"
                                name="caregiverMobileNr"
                                value={formInputs.caregiverMobileNr}
                                onChange={onInputChange}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Email ID"
                                name="emailId"
                                value={formInputs.emailId}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Relationship"
                                name="caregiverRelation"
                                value={formInputs.caregiverRelation}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <ComboboxField
                                label="ID Proof Type"
                                data={ID_PROOF_OPTIONS}
                                name="idProof"
                                textField="name"
                                setValue={formInputs.idProof}
                                getvalue={setDropdownData}
                              />
                            </Col>
                            {formInputs.idProof &&
                              formInputs.idProof !== "Select" && (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding mb-3"
                                >
                                  <InputField
                                    className="inputBox"
                                    label={`${formInputs.idProof} Number`}
                                    name="idProofNumber"
                                    placeholder={`Enter ${formInputs.idProof} number`}
                                    value={formInputs.idProofNumber}
                                    onChange={onInputChange}
                                    error={validation.idProofNumber}
                                  />
                                </Col>
                              )}
                          </Row>
                        </>
                      )}

                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          {selectedVendorCategory?.code === "V11"
                            ? "Personal Address"
                            : "Address Details"}
                        </h6>
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Lines 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs?.address || ""}
                          onChange={onInputChange}
                          error={validation?.address}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs?.address2 || ""}
                          onChange={onInputChange}
                          error={validation?.address2}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.country}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                        />
                      </Col>

                      {selectedVendorCategory?.code === "V12" && (
                        <>
                          {/*  Optional Details of Hospital for Individual Patinet */}
                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Hospital/Clinic Details Where You Visit
                            </h6>
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Name"
                              name="doctorHospitalName"
                              placeholder="Enter hospital or clinic name"
                              value={formInputs?.doctorHospitalName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Address"
                              name="doctorHospitalAddress"
                              placeholder="Enter hospital or clinic address"
                              value={formInputs?.doctorHospitalAddress || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalAddress}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital City"
                              name="doctorHospitalCity"
                              placeholder="Enter city"
                              value={formInputs?.doctorHospitalCity || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalCity}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital State"
                              name="doctorHospitalState"
                              placeholder="Enter state"
                              value={formInputs?.doctorHospitalState || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalState}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital Pincode"
                              name="doctorHospitalPincode"
                              placeholder="Enter pincode"
                              value={formInputs?.doctorHospitalPincode || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalPincode}
                            />
                          </Col>
                        </>
                      )}

                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          Other Details
                        </h6>
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          extraLabel="Company Code"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCodeCode"
                          description="companyCodeDesc"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          onChange={onInputChange}
                          error={validation.companyCode}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Sales Officer Name"
                          name="salesOfficerName"
                          code="salesOfficerCode"
                          description="salesOfficerDesc"
                          data={getSalesOfficerList}
                          id="salesOfficerName"
                          iconClassName="dropdownIcon"
                          // Disable if the user is NOT a Sales Admin
                          disabled={
                            !userData?.roles?.some(
                              (role) => role.roleId === "SALES-ADMIN",
                            )
                          }
                          setValue={formInputs?.salesOfficerName}
                          error={validation.salesOfficerName}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          min="2000-01-01"
                          label="Joining Date"
                          name="joiningDate"
                          id="joiningDate"
                          value={formInputs?.joiningDate || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="activeInactive"
                          >
                            Active/Inactive
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="activeInactive"
                            id="activeInactive"
                            checked={formInputs?.activeInactive || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                activeInactive: e.target.checked,
                              }))
                            }
                          />
                          <span className="ms-2">
                            {formInputs?.activeInactive ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*  HOSPITAL DOCTORS LIST (V04 only) */}
            {selectedVendorCategory?.code === "V04" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible10
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} className="text-center logoBtn">
                        <span className="iconLogo">DR</span>
                      </Col>
                      <Col xs={4} md={8} lg={8}>
                        <span className="headerTitle">Doctors List</span>
                        <span className="subHeaderTitle">
                          Add doctors employed by this hospital
                        </span>
                      </Col>
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={addDoctor}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add Doctor
                        </button>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible10 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      {getDoctorsList.map((doc) => (
                        <Row key={doc.id} className="mb-3 border-bottom pb-3">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title"
                              name="doctorTitle"
                              placeholder="e.g. DR, PM"
                              value={doc.doctorTitle}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorTitle",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Name"
                              placeholder="Enter Name of Doctor"
                              value={doc.doctorName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality Code"
                              name="doctorSpecialityCode"
                              placeholder="e.g. VS, DR, EN"
                              value={doc.doctorSpecialityCode}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityCode",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality"
                              name="doctorSpecialityName"
                              placeholder="e.g. Cardiology"
                              value={doc.doctorSpecialityName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              placeholder="e.g. Doctor, Physio"
                              value={doc.doctorType}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorType",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Gender"
                              name="doctorGender"
                              code="doctorGenderCode"
                              description="doctorGenderDesc"
                              id="doctorGender"
                              data={employeeGender}
                              setValue={doc?.doctorGender}
                              getvalue={setDropdownData}
                              index={doc.id}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              placeholder="e.g. FA, CORE"
                              value={doc.doctorClass}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorClass",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Rent Percentage"
                              name="doctorRentPercentage"
                              type="number"
                              value={doc.doctorRentPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorRentPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Discount Rate"
                              type="number"
                              name="doctorDiscountPercentage"
                              value={doc.doctorDiscountPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorDiscountPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={2}
                            lg={1}
                            className="commTopButtonRightLeftPadding"
                          >
                            <i
                              disabled={disabled}
                              onClick={() => deleteDoctor(doc.id)}
                              className="bi bi-trash text-danger fs-4 cursor-pointer"
                              title="Delete Doctor"
                            />
                          </Col>
                        </Row>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={6} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactPosition`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactTitle`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactName`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactNumber`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactEmail`
                                                ]
                                              }
                                            />
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id,
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4 cursor-pointer"
                                              title="Delete Contact"
                                            />
                                          </Col>
                                        </Row>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Document Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issuing Authority
                                        </p>
                                      </Col> */}
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            error={
                                              validation[
                                                `${doc.id}_documentType`
                                              ]
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            min="2000-01-01"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification,
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding d-flex"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                         
                                      
                                        </Col>
                                        
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4 cursor-pointer"
                                            title="Delete Document"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        // disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col> */}
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={item.id}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank IFSC ID"
                                name="bankIFSC"
                                placeholder=""
                                value={item?.bankIFSC}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankIFSC",
                                    e.target.value,
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAccountNumber",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankAccountNumber`]
                                    : ""
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankBranchName",
                                    e.target.value,
                                  )
                                }
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCountryDescription",
                                    e.target.value,
                                  )
                                }
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAddress",
                                    e.target.value,
                                  )
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.preferredCurrency || "INR"}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCurrency",
                                    e.target.value,
                                  )
                                }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "AccountHolderName",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_AccountHolderName`]
                                    : ""
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                code="swiftIfscCodeCode"
                                description="swiftIfscCodeDesc"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <FileUploadComponentForHB
                                  id="bankCompanyletterhead"
                                  name="bankCompanyletterhead"
                                  label="Company letterhead"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankCompanyletterhead || ""}
                                />
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  {item?.bankCompanyletterhead && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankCompanyletterhead,
                                        )
                                      }
                                    />
                                  )}
                                </Col>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <FileUploadComponentForHB
                                  id="bankConfirmationLetter"
                                  name="bankConfirmationLetter"
                                  label="Confirmation letter"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankConfirmationLetter || ""}
                                />
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  {item?.bankConfirmationLetter && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankConfirmationLetter,
                                        )
                                      }
                                    />
                                  )}
                                </Col>
                              </Col>
                            </Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left mb-4"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
    </main>
  );
};

export default UserRegistrationPageMR;
